import { createFileRoute, redirect } from '@tanstack/react-router'
import { useEffect } from 'react'
import { z } from 'zod'
import { authManager } from '../../auth-manager.ts'
import { SplashScreen } from '../../components/SplashScreen.tsx'

export const Route = createFileRoute('/_public/login')({
	beforeLoad: ({ search: { returnTo } }) => {
		if (authManager.isAuthenticated()) {
			throw redirect({ to: returnTo ?? '/' })
		}
	},
	validateSearch: z.object({
		returnTo: z.string().optional(),
	}),
	component: LoginPage,
})

function LoginPage() {
	const { returnTo } = Route.useSearch()

	useEffect(() => {
		authManager.login({ returnTo }).catch((error) => {
			console.error('Login failed', error)
		})
	}, [returnTo])

	return <SplashScreen />
}
